import { useState } from 'react';
import { Row, Col } from 'reactstrap';
import { useIntl, FormattedMessage } from 'react-intl';
import useAuth from 'src/hooks/useAuth';
import Panel from 'src/componentes/panel';
import { InputTranslate } from 'src/componentes/Form';
import Input from 'src/componentes/input';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import { capitalizeFirstLetter } from 'src/utils/string';
import ColaboradorSimplificadoLookup from 'src/lookups/ColaboradorSimplificadoLookup';
import StatusItemLookup from 'src/lookups/status-item';
import DataInicioTermino from 'src/paginas/formula/componentes/inicio-termino';
import TabelaRelacionamento from 'src/paginas/item/relacionamento';
import TagLookup from 'src/lookups/TagLookup';
import { TIPO_ITENS, STATUS_ITEM, ADDONS } from 'src/utils/constants';
import FaixaFarolList from 'src/paginas/item/edit/resumo/faixa-farol';
import Radio from 'src/componentes/radio';
import DesenharCampoCustomizado from 'src/paginas/item/campo-customizado/componentes/desenhar';
import errorHandler from 'src/utils/error-handler';
import LucideIcon from 'src/componentes/lucide-icon';
import ComentarioButton from 'src/componentes/comentarios/ComentarioButton';
import Historico from 'src/paginas/EscritorioProjetos/AprovacaoProjetos/Historico';
import ArquivoUploadAnexos from 'src/componentes/arquivo-upload/anexos';

const Resumo = ({
  model,
  selectedEtapa,
  shouldDisplayField,
  isFieldRequired,
  isEditable,
  isFieldEditable, //Função para manter campos de etapas anteriores somente leitura
  allAnexosConfigs = [], //Array com a configuração de todos os anexos das etapas anteriores + etapa atual
}) => {
  const intl = useIntl();
  const {
    terms: resources,
    configurations: { tiposAnexos },
    addons,
  } = useAuth();

  const possuiAddonProjetosAgeis = addons.find(
    (a) => a.id === ADDONS.PROJETOS_AGEIS && a.ativo
  );

  const stageGate = model?.getModel('stageGate').value;
  const etapaAtual = model?.getModel('etapaAtualStageGate').value;
  const etapaVisualizada = selectedEtapa ?? etapaAtual;
  const stageGateFinalizado = stageGate?.stageGateFinalizado === true;

  const [comentarioComponentKey, setcomentarioComponentKey] = useState(0);
  const [openHistorical, setOpenHistorical] = useState(false);

  const handleChangeInputTranslate = (field, value) => {
    model.getModel(field).requestChange(value);
  };

  const handleChangeEditTranslate = (
    fieldDefault,
    fieldPT,
    fieldEN,
    fieldES,
    fieldIT,
    fieldNL,
    fieldFR,
    fieldDE,
    fieldTR,
    fieldAR,
    localModel
  ) => {
    model.getModel(fieldDefault).requestChange(localModel[fieldDefault]);
    model.getModel(fieldPT).requestChange(localModel[fieldPT]);
    model.getModel(fieldEN).requestChange(localModel[fieldEN]);
    model.getModel(fieldES).requestChange(localModel[fieldES]);
    model.getModel(fieldIT).requestChange(localModel[fieldIT]);
    model.getModel(fieldNL).requestChange(localModel[fieldNL]);
    model.getModel(fieldFR).requestChange(localModel[fieldFR]);
    model.getModel(fieldDE).requestChange(localModel[fieldDE]);
    model.getModel(fieldTR).requestChange(localModel[fieldTR]);
    model.getModel(fieldAR).requestChange(localModel[fieldAR]);
  };

  const handleAreaChange = (value) => {
    model.getModel('area').requestChange(value);

    let usarCodigoArea = model.getModel('utilizarCodigoAreaParaMascara').value;
    if (usarCodigoArea) {
      let novoCodigoItem =
        value.idIntegracao + model.getModel('idIntegracao').value;
      model.getModel('idIntegracao').requestChange(novoCodigoItem);
    }
  };

  const validateSelectedRelatedProjects = async (projects) => {
    const currentProjectStartDate = model.getModel('dataInicioItem').value;
    const currentProjectEndDate = model.getModel('dataTerminoItem').value;
    const status = model.getModel('status').value;

    const acceptedMoves = (internalProject) =>
      status?.id != STATUS_ITEM.CONCLUIDO &&
      internalProject.dataInicioItemSemFormatacao >= currentProjectStartDate &&
      (!currentProjectEndDate ||
        (internalProject.dataTerminoItemSemFormatacao &&
          internalProject.dataTerminoItemSemFormatacao <=
            currentProjectEndDate));

    const validated = projects?.every((x) => acceptedMoves(x));

    if (!validated) {
      const promise = await new Promise((resolve) => {
        resolve({
          response: {
            data: {
              errorMessage: intl.formatMessage(
                { id: 'naoEhPossivelAssociarSubProjetosPeriodoInvalido' },
                {
                  projetos: resources.projetos,
                  projeto: resources.projeto,
                }
              ),
            },
          },
        });
      });
      errorHandler(promise);
    }

    return validated;
  };

  const handleComentarioCountChange = () => {
    setcomentarioComponentKey((prev) => prev + 1);
  };

  const getComentarioDialogTitle = (item) => {
    return `${intl.formatMessage({ id: 'estagio' })} : ${item?.nome || ''}`;
  };

  const getAnexoFilesModel = (anexoId, descricao) => {
    const anexosStageGateModel = model.getModel('anexosStageGateEtapas');
    if (!anexosStageGateModel) {
      return {
        value: [],
        requestChange: () => {},
        errors: null,
        label: descricao,
      };
    }

    const allFiles = anexosStageGateModel.value || [];
    const filesForThisAnexo = allFiles.filter(
      (file) => file.anexoStageGateEtapaId === anexoId
    );

    const handleRequestChange = (uploadedFiles) => {
      let currentAllFiles = [...allFiles];
      // Remove arquivos antigos deste anexo
      currentAllFiles = currentAllFiles.filter(
        (file) => file.anexoStageGateEtapaId !== anexoId
      );
      // Adiciona os novos arquivos já com o vínculo ao anexo
      const filesWithAssociation = uploadedFiles.map((file) => ({
        ...file,
        anexoStageGateEtapaId: anexoId,
      }));
      anexosStageGateModel.requestChange([
        ...currentAllFiles,
        ...filesWithAssociation,
      ]);
    };

    return {
      value: filesForThisAnexo,
      requestChange: handleRequestChange,
      errors: anexosStageGateModel.errors,
      label: descricao,
    };
  };

  return (
    <>
      <Panel className="overflow-y-auto">
        <Row className="mb-2">
          <Col>
            <div>
              <div className="text-muted text-sm">
                {intl.formatMessage({ id: 'fluxoAprovacao' })}
              </div>
              <div className={`font-weight-bolder`}>
                {etapaVisualizada?.fluxoAprovacao?.nome}
              </div>
            </div>
          </Col>
          <Col md={1} className="mr-2">
            <div className="d-flex">
              <ComentarioButton
                item={etapaVisualizada}
                tipoEntidade={10}
                dialogTitle={getComentarioDialogTitle(etapaVisualizada)}
                onCountChange={handleComentarioCountChange}
                key={comentarioComponentKey}
                entidadeId={etapaVisualizada.solicitacaoMudancaId}
                disabled={!etapaVisualizada.solicitacaoMudancaId}
              />
              <LucideIcon
                className="ml-2"
                style={{ cursor: 'pointer' }}
                icon="history"
                onClick={() => {
                  setOpenHistorical(true);
                }}
              />
            </div>
          </Col>
        </Row>
        {shouldDisplayField('nome') && (
          <Row>
            <Col>
              <InputTranslate
                id={model.getModel('id') && model.getModel('id').value}
                maxLength={300}
                fieldDefault={'nome'}
                errorsFieldDefault={model.getModel('nome').errors}
                valueDefault={model.getModel('nome').value}
                labelDefault={model.getModel('nome').label}
                fieldPT={'nomePT'}
                valuePT={model.getModel('nomePT').value}
                fieldEN={'nomeEN'}
                valueEN={model.getModel('nomeEN').value}
                fieldES={'nomeES'}
                valueES={model.getModel('nomeES').value}
                fieldIT={'nomeIT'}
                valueIT={model.getModel('nomeIT').value}
                fieldNL={'nomeNL'}
                valueNL={model.getModel('nomeNL').value}
                fieldFR={'nomeFR'}
                valueFR={model.getModel('nomeFR').value}
                fieldDE={'nomeDE'}
                valueDE={model.getModel('nomeDE').value}
                fieldTR={'nomeTR'}
                valueTR={model.getModel('nomeTR').value}
                fieldAR={'nomeAR'}
                valueAR={model.getModel('nomeAR').value}
                required={isFieldEditable('nome') && isFieldRequired('nome')}
                disabled={!isFieldEditable('nome')}
                autoFocus={true}
                handleChangeInputTranslate={handleChangeInputTranslate}
                handleChangeEditTranslate={handleChangeEditTranslate}
              />
            </Col>
          </Row>
        )}
        {shouldDisplayField('idIntegracao') && (
          <Row>
            <Col>
              <Input
                disabled={
                  model.getModel('utilizarCodigoAutomatico').value === true ||
                  !isFieldEditable('idIntegracao')
                }
                model={model.getModel('idIntegracao')}
                required={
                  isFieldEditable('idIntegracao') &&
                  !model.getModel('utilizarCodigoAutomatico').value &&
                  isFieldRequired('idIntegracao')
                }
              />
            </Col>
          </Row>
        )}
        {shouldDisplayField('area') && (
          <Row>
            <Col>
              <ItemOrganizacaoLookup
                required={isFieldEditable('area') && isFieldRequired('area')}
                data={{ tiposIdSelecionaveis: [1, 2, 3] }}
                model={{
                  label: capitalizeFirstLetter(resources.area),
                  value: model.getModel('area').value,
                  requestChange: handleAreaChange,
                  errors: model.getModel('area').errors,
                }}
                disabled={!isFieldEditable('area')}
              />
            </Col>
          </Row>
        )}
        {shouldDisplayField('responsaveis') && (
          <Row>
            <Col>
              <ColaboradorSimplificadoLookup
                multi
                required={
                  isFieldEditable('responsaveis') &&
                  isFieldRequired('responsaveis')
                }
                model={{
                  label: capitalizeFirstLetter(resources.responsaveisprojeto),
                  value: model.getModel('responsaveis').value,
                  requestChange: model.getModel('responsaveis').requestChange,
                  errors: model.getModel('responsaveis').errors,
                }}
                disabled={!isFieldEditable('responsaveis')}
              />
            </Col>
          </Row>
        )}
        {shouldDisplayField('status') && (
          <Row>
            <Col>
              <StatusItemLookup
                required={
                  isFieldRequired('status') && isFieldRequired('status')
                }
                model={{
                  label: model.getModel('status').label,
                  value: model.getModel('status').value,
                  requestChange: model.getModel('status').requestChange,
                }}
                disabled={
                  !stageGateFinalizado || model.getModel('status').value.id == 5
                }
                data={{ idsSelecionados: [1, 2, 3, 4, 5] }}
              />
            </Col>
          </Row>
        )}
        {shouldDisplayField('dataInicioItem') && (
          <Row>
            <Col>
              <DataInicioTermino
                required={
                  isFieldEditable('dataInicioItem') &&
                  isFieldRequired('dataInicioItem')
                }
                autoFormatDate={true}
                showClear={false}
                mesAno={false}
                dataInicio={model.getModel('dataInicioItem')}
                dataTermino={model.getModel('dataTerminoItem')}
                disabled={!isFieldEditable('dataInicioItem')}
              />
            </Col>
          </Row>
        )}
        {shouldDisplayField('equipe') &&
          model.getModel('configuracaoGeral').value?.habilitarEquipe && (
            <Row>
              <Col>
                <ColaboradorSimplificadoLookup
                  multi
                  required={
                    isFieldEditable('equipe') && isFieldRequired('equipe')
                  }
                  disabled={!isFieldEditable('equipe')}
                  model={{
                    label: intl.formatMessage({ id: 'equipe' }),
                    value: model.getModel('equipe').value,
                    requestChange: model.getModel('equipe').requestChange,
                    errors: model.getModel('equipe').errors,
                  }}
                />
              </Col>
            </Row>
          )}
        {shouldDisplayField('escopo') && (
          <Row>
            <Col>
              <Input
                rows={3}
                maxLength={4000}
                type="textarea"
                model={{
                  label: model.getModel('escopo').label,
                  value: model.getModel('escopo').value,
                  requestChange: model.getModel('escopo').requestChange,
                }}
                disabled={!isFieldEditable('escopo')}
                required={
                  isFieldEditable('escopo') && isFieldRequired('escopo')
                }
              />
            </Col>
          </Row>
        )}
        {shouldDisplayField('subProjetos') &&
          0 == 0 &&
          model.value &&
          model.value.id != 0 && (
            <Row>
              <Col>
                <Panel header={capitalizeFirstLetter(resources.projetosfilhos)}>
                  <Row>
                    <Col md={12} style={{ marginTop: 20 }}>
                      <TabelaRelacionamento
                        parameters={
                          possuiAddonProjetosAgeis
                            ? {
                                tiposIdsSelecionados: [
                                  TIPO_ITENS.PROJETO,
                                  TIPO_ITENS.PROJETOS_AGEIS,
                                ],
                                itemIdIgnorar:
                                  model.getModel('id').value || undefined,
                              }
                            : {
                                tipoId: TIPO_ITENS.PROJETO,
                                itemIdIgnorar:
                                  model.getModel('id').value || undefined,
                              }
                        }
                        allowNew={isFieldEditable('subProjetos')}
                        disabled={!isFieldEditable('subProjetos')}
                        model={model.getModel('filhos')}
                        validateResults={validateSelectedRelatedProjects}
                      ></TabelaRelacionamento>
                    </Col>
                  </Row>
                </Panel>
              </Col>
            </Row>
          )}
        {shouldDisplayField('tags') && (
          <Row>
            <Col>
              <TagLookup
                multi
                required={isFieldEditable('tags') && isFieldRequired('tags')}
                model={{
                  label: capitalizeFirstLetter(
                    intl.formatMessage({ id: 'tags' }, { tags: resources.tags })
                  ),
                  value: model.getModel('tags').value,
                  requestChange: model.getModel('tags').requestChange,
                }}
                disabled={!isFieldEditable('tags')}
                data={{ funcionalidadesIdSelecionaveis: [TIPO_ITENS.PROJETO] }}
                podeEditar={model.getModel('podeCadastrarTag').value}
              />
            </Col>
          </Row>
        )}
        {shouldDisplayField('faixaDeFarol') &&
          model.getModel('configuracaoGeral').value
            ?.utilizarFarolDesempenhoFaixa && (
            <Row>
              <Col>
                <Panel header={<FormattedMessage id="label.referencia" />}>
                  <Row>
                    <Col>
                      <Row>
                        <Col md={6}>
                          <Radio
                            model={{
                              label: capitalizeFirstLetter(
                                resources.polaridade
                              ),
                              value: model.getModel('melhor').value,
                              requestChange:
                                model.getModel('melhor').requestChange,
                            }}
                            name="polaridade"
                            options={model.value.opcoesMelhor}
                            disabled={true}
                            labelField="descricao"
                            idField="id"
                          />
                        </Col>
                      </Row>
                      {model?.getModel('id')?.value > 0 && (
                        <Row>
                          <Col md={12}>
                            <FaixaFarolList
                              modelItem={model}
                              disabled={!isFieldEditable('faixaDeFarol')}
                              podeEditar={true}
                              tipoItem={4}
                            />
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Panel>
              </Col>
            </Row>
          )}
        {model.getModel('camposCustomizados').value &&
          model.getModel('camposCustomizados').value.length > 0 && (
            <Row>
              <Col>
                <DesenharCampoCustomizado
                  model={model.getModel('camposCustomizados')}
                  disabled={!isEditable}
                  shouldDisplayField={shouldDisplayField}
                  isRequiredField={isFieldRequired}
                  isFieldEditable={isFieldEditable}
                />
              </Col>
            </Row>
          )}
        {allAnexosConfigs.map((anexo) => {
          const anexoId = anexo.id;
          if (!shouldDisplayField(anexoId.toString())) return null;

          const anexoModel = getAnexoFilesModel(anexoId, anexo.descricao);
          const isEditableField = isFieldEditable(anexoId.toString());
          const isRequiredField = isFieldRequired(anexoId.toString());

          return (
            <div key={anexoId} className="mt-3">
              <ArquivoUploadAnexos
                formGroupStyle={{ marginBottom: 0 }}
                onlyRead={!isEditableField}
                required={isEditableField && isRequiredField}
                model={anexoModel}
                tipoAnexo={tiposAnexos.item}
              />
            </div>
          );
        })}
      </Panel>
      <Historico
        openHistorical={openHistorical}
        setOpenHistorical={setOpenHistorical}
        projetoId={model.getModel('id').value}
        etapaStageGateId={etapaVisualizada.id}
        nomeProjeto={model.getModel('nome').value}
      />
    </>
  );
};

export default Resumo;
